import type { SVGProps } from 'react';

const SvgAnnotationRedo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.5 6h6.59L15.8 4.71a.996.996 0 1 1 1.41-1.41l3 3c.39.39.39 1.02 0 1.41l-3 3c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l1.29-1.29h-6.59a5.51 5.51 0 0 0-5.5 5.5c0 3.03 2.47 5.5 5.5 5.5h8c.55 0 1 .45 1 1s-.45 1-1 1H10.5C6.36 21 3 17.64 3 13.5S6.36 6 10.5 6"
    />
  </svg>
);
export default SvgAnnotationRedo;
